<template>
  <div class="danmu-standalone-page">
    <app-danmu-console :show-backend-fullscreen="false"></app-danmu-console>
  </div>
</template>

<script>
import appDanmuConsole from "@/components/appDanmuConsole.vue";

export default {
  name: "appDanmuConsoleStandalone",
  components: { appDanmuConsole },
};
</script>

<style scoped>
.danmu-standalone-page {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: #f8fafc;
}
</style>
